import { PROVINCE_NAMES } from "../../lib/tone";

export const PageHero = ({ eyebrow, title, sub, img, alt, children, testId }) => (
  <section className="relative overflow-hidden bg-[#1E3A8A]" data-testid={testId}>
    <img src={img} alt={alt} className="absolute inset-0 h-full w-full object-cover opacity-35" />
    <div className="absolute inset-0 bg-gradient-to-r from-[#1E3A8A] via-[#1E3A8A]/85 to-transparent" />
    <div className="relative mx-auto max-w-7xl px-5 py-14 sm:px-8 sm:py-16">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-green-300">{eyebrow}</p>
      <h1 className="mt-4 max-w-2xl text-4xl font-bold tracking-tight text-white sm:text-5xl">{title}</h1>
      <p className="mt-4 max-w-xl text-base text-blue-100 md:text-lg">{sub}</p>
      {children}
    </div>
  </section>
);

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export const CategoryChips = ({ cats, value, onChange, prefix }) => (
  <div className="flex flex-wrap gap-2" data-testid={`${prefix}-category-chips`}>
    {[{ name: "", count: null }, ...cats].map((c) => (
      <button key={c.name || "all"} onClick={() => onChange(c.name)} aria-pressed={value === c.name} data-testid={`${prefix}-cat-${c.name ? slug(c.name) : "all"}`}
        className={`rounded-full border px-3.5 py-1.5 text-sm font-medium transition-colors ${value === c.name ? "border-[#1E3A8A] bg-[#1E3A8A] text-white" : "border-slate-200 bg-white text-slate-700 hover:border-[#1E3A8A]"}`}>
        {c.name || "All"}{c.count != null && <span className="ml-1 opacity-70">{c.count}</span>}
      </button>
    ))}
  </div>
);

export const ProvinceSelect = ({ value, onChange, testId }) => (
  <select value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId} aria-label="Province"
    className="rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-sm text-slate-700">
    <option value="">All of Canada</option>{Object.entries(PROVINCE_NAMES).map(([c, n]) => <option key={c} value={c}>{n}</option>)}
  </select>
);

export const SearchInput = ({ value, onChange, placeholder, testId }) => (
  <input value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} data-testid={testId} aria-label="Search"
    className="min-w-0 flex-1 basis-full rounded-xl sm:basis-0 border border-slate-200 bg-white px-3 py-2.5 text-sm text-slate-700" />
);
